import axios from "axios";

const holidaysCache = {};

const toIsoDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const fetchFeriadosArgentina = async (year) => {
  if (holidaysCache[year]) return holidaysCache[year];

  try {
    const { data } = await axios.get(`https://date.nager.at/api/v3/PublicHolidays/${year}/AR`);
    holidaysCache[year] = new Set(data.map((feriado) => feriado.date));
  } catch (err) {
    console.error("No se pudieron obtener los feriados de Argentina:", err);
    holidaysCache[year] = new Set();
  }

  return holidaysCache[year];
};

const esFinDeSemana = (date) => date.getDay() === 0 || date.getDay() === 6;

/**
 * Calcula la fecha de vencimiento por default de una liquidación: el día 10
 * del mes siguiente al período liquidado, corrida al siguiente día hábil si
 * cae fin de semana o feriado nacional.
 */
export const getDefaultFechaVencimiento = async (periodo) => {
  const base = periodo instanceof Date ? periodo : new Date(periodo);
  const fecha = new Date(base.getFullYear(), base.getMonth() + 1, 10);

  const feriados = await fetchFeriadosArgentina(fecha.getFullYear());

  while (esFinDeSemana(fecha) || feriados.has(toIsoDate(fecha))) {
    fecha.setDate(fecha.getDate() + 1);
  }

  return fecha;
};
